/**
 * I tag di strategia di una posizione, in piccolo (SPEC-028).
 *
 * Un tag con l'evento o la revisione gia' passati si vede diverso: e' il caso
 * che il revisore della sera deve trattare per primo, e chi guarda la tabella
 * deve poterlo notare senza aprire niente.
 */

import type { ActiveStrategyTag, StrategyCatalogItem } from './api';
import { describeParams, isExpired } from './strategy-format';
import './strategy-tags.css';

type StrategyChipsProps = {
  tags: ActiveStrategyTag[];
  catalog: StrategyCatalogItem[] | undefined;
  now?: Date;
};

export function StrategyChips({ tags, catalog, now = new Date() }: StrategyChipsProps) {
  if (tags.length === 0) return null;
  const byTag = new Map((catalog ?? []).map((item) => [item.tag, item]));
  return (
    <ul className="strategy-chips" aria-label="Tag di strategia">
      {tags.map((tag) => {
        const item = byTag.get(tag.tag);
        const expired = isExpired(tag.params, now);
        const details = describeParams(tag.params);
        return (
          <li
            key={tag.id}
            className={`strategy-chip strategy-chip--${item?.dimension ?? 'thesis'}${expired ? ' strategy-chip--expired' : ''}`}
            title={[item?.description, details, expired ? 'Scadenza superata' : null].filter(Boolean).join('\n')}
          >
            {item?.label ?? tag.tag}
            {expired && <span className="visually-hidden"> (scaduto)</span>}
          </li>
        );
      })}
    </ul>
  );
}
